import { SideNavProvider } from '@atlassian/conversation-assistant';
import React, { Suspense } from 'react';

// Lazy load the RovoSidebarNavigation to avoid pulling in @atlassian/rovo-navigation
// unless the Rovo chat experiment is actually enabled
const RovoSidebarNavigation = React.lazy(() =>
	import('./RovoSidebarNavigation').then(module => ({
		default: module.RovoSidebarNavigation,
	})),
);

export const LazyRovoSidebarNavigation = () => {
	const content = (
		<Suspense fallback={null}>
			<RovoSidebarNavigation />
		</Suspense>
	);

	return <SideNavProvider>{content}</SideNavProvider>;
};
